<template>
    <div class="logout-btn">
        <a href="#!" @click="logout()" class="btn btn-primary">Logout <i class="bi bi-box-arrow-right ml-2"></i></a>
    </div>
</template>
<script>
import SwalMixin from "../../mixins/swalMixin";

export default {
    mixins: [SwalMixin],
    methods: {
        logout() {
            this.fireSwal('Are you sure want to logout?', 'warning').then((result) => {
                if (result.isConfirmed) {
                    axios.post("logout").then(() => {
                        this.$store.commit("setUserLoggedOut");
                        this.$router.push({name: "login"});
                    });
                }
            });
        },
    }
}


</script>
